'use strict';

var m = angular.module('ui.utils.masks.ch', [
	require('../helpers'),
])
.directive('uiChPhoneNumber', require('./phone/ch-phone'));

module.exports = m.name;



//////////////////
// WEBPACK FOOTER
// ./~/angular-input-masks/src/ch/ch-masks.js
// module id = 585
// module chunks = 1